import { type ReactElement } from 'react'
import { type FooterProps } from './footer.props'
import { FullFooter } from './full-footer'
import * as S from './footer.styled'
import { Terms } from './terms'
import { Link } from 'react-router-dom'

export function Footer ({ full }: FooterProps): ReactElement {
  return <S.Container>
    <S.Content>
      {full
        ? <FullFooter />
        : <>
          <Terms />
          <S.Disclaimer>
            * Cartão de desconto não é plano de saúde, não garante e não se responsabiliza pelos serviços oferecidos e pelo pagamento das despesas, nem assegura desconto em todos os serviços obrigatoriamente garantidos por plano de saúde. Tudo o que o cliente usar ou comprar será por ele pago ao prestador, assegurando-se apenas os preços e descontos que constam na relação de empresas e serviços conveniados disponibilizados no site <Link to="www.cartaodetodos.com.br" target="_blank" rel="noreferrer noopener">www.cartaodetodos.com.br</Link>. O atendimento será em até 15 dias, mediante disponibilidade na clínica. Consulte a clínica parceira para as especialidades disponíveis e condições para marcar as consultas.
          </S.Disclaimer>
          <S.Copyright>TODOS Empreendimentos LTDA - CNPJ: 04.644.515/0001-85</S.Copyright>
        </>}
    </S.Content>
  </S.Container>
}
